/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_5_CalendlyInputs */

const en_privacy_section_5_calendly = /** @type {(inputs: Privacy_Section_5_CalendlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cal.com`)
};

const lv_privacy_section_5_calendly = /** @type {(inputs: Privacy_Section_5_CalendlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cal.com`)
};

/**
* | output |
* | --- |
* | "Cal.com" |
*
* @param {Privacy_Section_5_CalendlyInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_5_calendly = /** @type {((inputs?: Privacy_Section_5_CalendlyInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_5_CalendlyInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_5_calendly(inputs)
	return en_privacy_section_5_calendly(inputs)
});